var map = {
	"./gameplay-chokwin-xsmall.webp": [
		61446,
		61446
	],
	"./gameplay-gannar-xsmall.webp": [
		42864,
		42864
	],
	"./gameplay-luckykingbet-xsmall.webp": [
		10275,
		10275
	],
	"./gameplay-mars-br-xsmall.webp": [
		81362,
		81362
	],
	"./gameplay-mars-es-xsmall.webp": [
		48706,
		48706
	],
	"./gameplay-mars-mx-xsmall.webp": [
		62022,
		62022
	],
	"./gameplay-mars-pt-xsmall.webp": [
		26951,
		26951
	],
	"./gameplay-mars-ru-xsmall.webp": [
		33694,
		33694
	],
	"./gameplay-mars-th-xsmall.webp": [
		28185,
		28185
	],
	"./gameplay-mars-xsmall.webp": [
		11344,
		11344
	],
	"./gameplay-zenginsin-xsmall.webp": [
		65081,
		65081
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 47299;
module.exports = webpackAsyncContext;